if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    idleTaskHandles = [];
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      this.initAppBlockVisibility();
      if (this.querySelector('[data-review-rotator]')) {
        this.scheduleIdleTask(() => this.initReviewRotators(), 2000);
      }
      if (this.hasReelUpAppBlock()) {
        this.scheduleIdleTask(() => this.initReelUpNavigationHeading(), 2500);
      }

      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      this.cancelIdleTasks();

      if (this.showAppBlocksHandler) {
        window.removeEventListener('load', this.showAppBlocksHandler);
      }

      if (this.reviewRotatorTimers) {
        this.reviewRotatorTimers.forEach((timer) => window.clearInterval(timer));
        this.reviewRotatorTimers = [];
      }

      if (this.reelUpNavigationObserver) {
        this.reelUpNavigationObserver.disconnect();
      }

      if (this.reelUpNavigationFrame) {
        window.cancelAnimationFrame(this.reelUpNavigationFrame);
        this.reelUpNavigationFrame = undefined;
      }

      if (this.reelUpNavigationStopTimer) {
        window.clearTimeout(this.reelUpNavigationStopTimer);
        this.reelUpNavigationStopTimer = undefined;
      }

      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    scheduleIdleTask(callback, timeout = 1500) {
      if ('requestIdleCallback' in window) {
        const handle = window.requestIdleCallback(() => {
          if (this.isConnected) callback();
        }, { timeout });

        this.idleTaskHandles.push({ handle, type: 'idle' });
        return;
      }

      const handle = window.setTimeout(() => {
        if (this.isConnected) callback();
      }, timeout);

      this.idleTaskHandles.push({ handle, type: 'timeout' });
    }

    cancelIdleTasks() {
      if (!this.idleTaskHandles.length) return;

      this.idleTaskHandles.forEach(({ handle, type }) => {
        if (type === 'idle' && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(handle);
        } else {
          window.clearTimeout(handle);
        }
      });
      this.idleTaskHandles = [];
    }

    initReviewRotators() {
      const reviewRotators = this.querySelectorAll('[data-review-rotator]');

      if (!reviewRotators.length) return;

      this.reviewRotatorTimers = this.reviewRotatorTimers || [];
      this.reviewRotatorTimers.forEach((timer) => window.clearInterval(timer));
      this.reviewRotatorTimers = [];

      reviewRotators.forEach((reviewRotator) => {
        const reviewItemsNode = reviewRotator.querySelector('[data-review-items]');
        if (!reviewItemsNode) return;

        let reviewItems = [];

        try {
          reviewItems = JSON.parse(reviewItemsNode.textContent);
        } catch (error) {
          console.error('Unable to parse product review items', error);
          return;
        }

        if (!Array.isArray(reviewItems) || reviewItems.length <= 1) return;

        const storageKey = reviewRotator.dataset.storageKey;
        const interval = parseInt(reviewRotator.dataset.rotationInterval, 10) || 5000;
        const savedIndex = storageKey ? this.getStoredReviewIndex(storageKey) : 0;
        const initialIndex = Number.isInteger(savedIndex) && savedIndex >= 0 ? savedIndex % reviewItems.length : 0;

        this.updateReviewRotator(reviewRotator, reviewItems[initialIndex]);

        const timer = window.setInterval(() => {
          const currentIndex = parseInt(reviewRotator.dataset.reviewIndex || initialIndex, 10) || 0;
          const nextIndex = (currentIndex + 1) % reviewItems.length;

          this.updateReviewRotator(reviewRotator, reviewItems[nextIndex], nextIndex, storageKey);
        }, interval);

        this.reviewRotatorTimers.push(timer);
      });
    }

    updateReviewRotator(reviewRotator, review, index = 0, storageKey = '') {
      const quote = reviewRotator.querySelector('[data-review-quote]');
      const name = reviewRotator.querySelector('[data-review-name]');
      const role = reviewRotator.querySelector('[data-review-role]');
      const imageWrapper = reviewRotator.querySelector('.product__metafield-review-image-wrapper');
      let image = reviewRotator.querySelector('.product__metafield-review-image');

      if (quote) {
        quote.textContent = review.quote || '';
        quote.hidden = !review.quote;
      }

      if (name) {
        name.textContent = review.name || '';
      }

      if (role) {
        role.textContent = review.role || '';
        role.hidden = !review.role;
      }

      if (imageWrapper) {
        if (review.image) {
          if (!image || image.tagName !== 'IMG') {
            const nextImage = document.createElement('img');

            nextImage.className = 'product__metafield-review-image';
            nextImage.width = 48;
            nextImage.height = 48;
            nextImage.loading = 'lazy';
            imageWrapper.innerHTML = '';
            imageWrapper.appendChild(nextImage);
            image = nextImage;
          }

          image.src = review.image;
          image.alt = review.name || '';
        } else if (imageWrapper) {
          imageWrapper.innerHTML = '<div class="product__metafield-review-image product__metafield-review-image--placeholder" aria-hidden="true"></div>';
        }
      }

      reviewRotator.dataset.reviewIndex = index;

      if (storageKey) {
        this.setStoredReviewIndex(storageKey, index);
      }
    }

    getStoredReviewIndex(storageKey) {
      try {
        return parseInt(window.localStorage.getItem(storageKey), 10);
      } catch (error) {
        return 0;
      }
    }

    setStoredReviewIndex(storageKey, index) {
      try {
        window.localStorage.setItem(storageKey, index);
      } catch (error) {
        return;
      }
    }

    initAppBlockVisibility() {
      const appBlocks = this.querySelectorAll('.shopify-app-block');

      if (!appBlocks.length) return;

      const showAppBlocks = () => {
        this.classList.add('app-blocks-ready');
      };

      this.showAppBlocksHandler = showAppBlocks;

      if (document.readyState === 'complete') {
        showAppBlocks();
        return;
      }

      this.classList.remove('app-blocks-ready');
      window.addEventListener('load', showAppBlocks, { once: true });
    }

    hasReelUpAppBlock() {
      return Boolean(this.querySelector('.shopify-app-block, [id*="reelUp"], [class*="reelUp"]'));
    }

    initReelUpNavigationHeading() {
      if (!this.hasReelUpAppBlock() || this.reelUpNavigationObserver) return;

      const syncNavigationHeading = () => {
        const scope = this.closest('.product__info-wrapper') || this;
        const navigationNodes = scope.querySelectorAll('.reelUp_carousel_navigation');
        let syncedCount = 0;

        if (!navigationNodes.length) return false;

        navigationNodes.forEach((navigationNode) => {
          const headingNode = this.getReelUpHeadingNode(navigationNode);

          if (!headingNode) return;

          this.normalizeReelUpHeadingContent(headingNode);

          if (!navigationNode.contains(headingNode)) {
            navigationNode.prepend(headingNode);
          }

          syncedCount += 1;
        });

        return syncedCount === navigationNodes.length;
      };

      const stopObserving = () => {
        if (this.reelUpNavigationObserver) {
          this.reelUpNavigationObserver.disconnect();
          this.reelUpNavigationObserver = undefined;
        }

        if (this.reelUpNavigationFrame) {
          window.cancelAnimationFrame(this.reelUpNavigationFrame);
          this.reelUpNavigationFrame = undefined;
        }

        if (this.reelUpNavigationStopTimer) {
          window.clearTimeout(this.reelUpNavigationStopTimer);
          this.reelUpNavigationStopTimer = undefined;
        }
      };

      const requestSync = () => {
        if (this.reelUpNavigationFrame) return;

        this.reelUpNavigationFrame = window.requestAnimationFrame(() => {
          this.reelUpNavigationFrame = undefined;

          if (syncNavigationHeading()) {
            stopObserving();
          }
        });
      };

      if (syncNavigationHeading()) return;

      this.reelUpNavigationObserver = new MutationObserver(requestSync);

      this.reelUpNavigationObserver.observe(this, {
        childList: true,
        subtree: true,
      });

      this.reelUpNavigationStopTimer = window.setTimeout(() => {
        syncNavigationHeading();
        stopObserving();
      }, 12000);
    }

    getReelUpHeadingNode(navigationNode) {
      const currentHeadingNode = navigationNode.querySelector('.reelUp_slider_heading.reelUp_widget_heading');

      if (currentHeadingNode) return currentHeadingNode;

      const widgetRoot = this.getReelUpWidgetRoot(navigationNode);

      if (!widgetRoot) return document.querySelector('.reelUp_slider_heading.reelUp_widget_heading');

      const widgetHeadingNode = widgetRoot.querySelector('.reelUp_slider_heading.reelUp_widget_heading');

      if (widgetHeadingNode) return widgetHeadingNode;

      return document.querySelector('.reelUp_slider_heading.reelUp_widget_heading');
    }

    getReelUpWidgetRoot(node) {
      if (!node) return null;

      return node.closest(
        '[id*="reelUp"], [class*="reelUp_widget"], [class*="reelUp_cards_carousel"], [class*="reelUp_carousel_wrapper"], [class*="reelUp_slider"]'
      );
    }

    normalizeReelUpHeadingContent(headingNode) {
      const rawContent = headingNode.innerHTML.trim();

      if (!rawContent || rawContent.includes('<span') || rawContent.includes('<div') || rawContent.includes('<strong') || rawContent.includes('<em') || rawContent.includes('<br')) {
        return;
      }

      const decodedContent = this.decodeHtmlString(rawContent);

      if (!decodedContent || decodedContent === rawContent) return;

      headingNode.innerHTML = decodedContent;
    }

    decodeHtmlString(value) {
      const textarea = document.createElement('textarea');

      textarea.innerHTML = value;

      return textarea.value;
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      const loadingOverlay = this.querySelector('.quantity__rules-cart .loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      if (!quantityFormUpdated || !this.quantityForm) return;
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};

